"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var debounce = require("lodash.debounce");
var DEFAULT_TIMEOUT_MS = 2000;
var CONFIG = {
    apiKey: null,
    host: null,
    timeout: DEFAULT_TIMEOUT_MS,
    local: false,
    ravenClient: null,
};
var QUEUED_EVENTS = [];
var QUEUED_GAUGES = [];
var send;
var removeEmpty = function (obj, levels) {
    if (levels === void 0) { levels = 10; }
    if (levels === 0) {
        return obj;
    }
    Object.keys(obj).forEach(function (key) {
        if (obj[key] && typeof obj[key] === 'object')
            removeEmpty(obj[key], levels - 1);
        // eslint-disable-next-line
        else if (obj[key] == null)
            delete obj[key];
    });
    return obj;
};
var setupRequest = function (endpoint) {
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.open('POST', CONFIG.host + "/v1/" + endpoint);
    xmlhttp.timeout = CONFIG.timeout;
    xmlhttp.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    xmlhttp.setRequestHeader('Authorization', "EAPIV1 " + CONFIG.apiKey);
    return xmlhttp;
};
var postEvents = function () {
    if (QUEUED_EVENTS.length === 0) {
        return;
    }
    var xmlhttp = setupRequest('events');
    try {
        xmlhttp.send(JSON.stringify(QUEUED_EVENTS.map(function (ev) { return removeEmpty(ev); })));
    }
    finally {
        // Clear the queue even if there's an exception serializing an event
        QUEUED_EVENTS.length = 0;
    }
};
var postGauges = function () {
    if (QUEUED_GAUGES.length === 0) {
        return;
    }
    var xmlhttp = setupRequest('gauges');
    try {
        xmlhttp.send(JSON.stringify({ gauges: QUEUED_GAUGES }));
    }
    finally {
        // Clear the queue even if there's an exception serializing an event
        QUEUED_GAUGES.length = 0;
    }
};
var nonBufferedSend = function () {
    postEvents();
    postGauges();
};
var buildSendFunction = function (buffer) {
    if (buffer && buffer !== 0) {
        return debounce(nonBufferedSend, buffer);
    }
    return nonBufferedSend;
};
function configure(opts) {
    CONFIG.apiKey = opts.apiKey;
    CONFIG.host = opts.host;
    CONFIG.timeout = opts.timeout || DEFAULT_TIMEOUT_MS;
    CONFIG.local = opts.local;
    send = buildSendFunction(opts.buffer);
}
function post(events, endpoint) {
    if (CONFIG.local) {
        // eslint-disable-next-line
        console.log('[event-api] ', JSON.stringify(events));
    }
    if (!CONFIG.apiKey || !CONFIG.host) {
        return;
    }
    if (endpoint === 'events') {
        Array.prototype.push.apply(QUEUED_EVENTS, events);
    }
    if (endpoint === 'gauges') {
        Array.prototype.push.apply(QUEUED_GAUGES, events);
    }
    send();
}
exports.default = {
    post: post,
    configure: configure,
};



//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.ecs-deploy.production/build/src/node_modules/@reverbdotcom/elog/dist/client.js
// module id = QRSd
// module chunks = 20